<template>
  <!-- Table Container Card -->
  <div style="height: inherit">
    <b-card id="page-products" no-body class="mb-0 p-2">
      <b-card-header
        class="pl-0 pr-0 d-flex align-items-between justify-content-center"
      >
        <b-col cols="12" md="4">
          <b-card-title
            ><h2>{{ $t(label("title")) }}</h2></b-card-title
          >
        </b-col>

        <b-col v-if="canCreate" cols="12" md="8" class="d-none d-md-table">
          <b-col
            cols="12"
            class="d-flex align-items-between justify-content-end"
          >
            <input
              id="files"
              ref="files"
              name="files"
              type="file"
              class="hidden"
              accept=".xlsx"
              @change="onFileChange($event)"
            />

            <b-button
              variant="warning"
              @click="updloadValery"
              class="mr-1"
              :disabled="loading"
            >
              <feather-icon icon="UploadCloudIcon" class="mr-25" size="18" />
              <span class="text-nowrap">{{ $t(label("uploadValery")) }}</span>
            </b-button>

            <b-button
              variant="danger"
              @click="updloadProducts"
              class="mr-1"
              :disabled="loading"
            >
              <feather-icon icon="UploadCloudIcon" class="mr-25" size="18" />
              <span class="text-nowrap">{{ $t(label("uploadExcel")) }}</span>
            </b-button>
            <b-button
              id="tooltip-downlaod"
              variant="success"
              @click="dowloandsCatalog"
              class="mr-1"
              :disabled="loading"
            >
              <feather-icon icon="DownloadCloudIcon" class="mr-25" size="18" />
              <span class="text-nowrap">{{ $t(label("download")) }}</span>
            </b-button>

            <b-button id="tooltip-create" variant="primary" @click="onCreate">
              <feather-icon icon="PlusIcon" class="mr-25" size="18" />
              <span class="text-nowrap">{{ $t(label("register")) }}</span>
            </b-button>
          </b-col>
        </b-col>

        <b-col
          v-if="canCreate"
          cols="12"
          sm="12"
          md="8"
          lg="8"
          xl="8"
          class="d-md-none d-flex justify-content-between align-items-center pt-2"
        >
          <b-button
            id="tooltip-upload"
            variant="warning"
            @click="updloadValery"
            class="btn-icon"
            :disabled="loading"
          >
            <feather-icon icon="UploadCloudIcon" size="18" />
          </b-button>
          <b-button
            id="tooltip-upload"
            variant="danger"
            @click="updloadProducts"
            class="btn-icon"
            :disabled="loading"
          >
            <feather-icon icon="UploadCloudIcon" size="18" />
          </b-button>
          <b-button
            id="tooltip-downlaod"
            variant="success"
            @click="dowloandsCatalog"
            class="btn-icon"
            :disabled="loading"
          >
            <feather-icon icon="DownloadCloudIcon" size="18" />
          </b-button>
          <b-button
            id="tooltip-create"
            variant="primary"
            @click="onCreate"
            class="btn-icon"
          >
            <feather-icon icon="PlusIcon" size="18" />
          </b-button>
        </b-col>

        <b-tooltip
          placement="top"
          target="tooltip-create"
          triggers="hover"
          @click="onInfo"
        >
          <strong>
            <feather-icon icon="ExternalLinkIcon" class="mr-25 mt-0" />
            Ver tutorial
          </strong>
          <span> </span>
        </b-tooltip>
      </b-card-header>

      <Filterss
        :fields="fildsToFilters"
        :model="model"
        @filter-applied="applyFilters"
        @filter-reset="resetFilters"
      />

      <!-- Prodcuts -->
      <section v-if="!loading" class="grid-view">
        <b-card
          border-variant="primary"
          v-for="product in items"
          :key="product.id"
          class="ecommerce-card"
          no-body
        >
          <div class="d-flex pt-1 pr-1 justify-content-end">
            <b-dropdown
              variant="link"
              no-caret
              class="chart-dropdown"
              toggle-class="p-0"
              right
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="text-body cursor-pointer"
                />
              </template>
              <b-dropdown-item v-if="canShow" @click="onShow(product.guid)">
                <div class="d-flex align-items-center justify-content-between">
                  <feather-icon
                    class="text-success mr-25"
                    size="18"
                    icon="FileTextIcon"
                  />
                  {{ $t("show") }}
                </div>
              </b-dropdown-item>
              <b-dropdown-item v-if="canEdit" @click="onEdit(product.guid)">
                <div class="d-flex align-items-center justify-content-between">
                  <feather-icon
                    class="text-primary mr-25"
                    size="18"
                    icon="EditIcon"
                  />
                  {{ $t("edit") }}
                </div>
              </b-dropdown-item>
              <b-dropdown-item v-if="canEdit" @click="onClone(product.guid)">
                <div class="d-flex align-items-center justify-content-between">
                  <feather-icon
                    class="text-info mr-25"
                    size="18"
                    icon="CopyIcon"
                  />
                  {{ $t("clone") }}
                </div>
              </b-dropdown-item>
              <b-dropdown-item v-if="canDelete" @click="onDelete(product.guid)">
                <div class="d-flex align-items-center justify-content-between">
                  <feather-icon
                    class="text-danger"
                    size="18"
                    icon="Trash2Icon"
                  />
                  {{ $t("delete") }}
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="item-img text-center">
            <!-- <b-link
            :to="{
              name: 'apps-e-commerce-product-details',
              params: { slug: product.slug },
            }"
          > -->
            <b-carousel
              id="carousel-example-generic"
              controls
              indicators
              class="product-carousel"
            >
              <b-carousel-slide
                v-for="photo in product.photos"
                :key="photo.idProductPhoto"
              >
                <template #img>
                  <div class="image-wrapper">
                    <img
                      class="product-image"
                      :src="photo.urlPhoto"
                      :alt="`${product.name} - ${photo.idProductPhoto}`"
                    />
                  </div>
                </template>
              </b-carousel-slide>
            </b-carousel>
            <!-- <b-img
              :alt="`${product.name}-${product.id}`"
              fluid
              class="card-img-top"
              :src="product.image"
            /> -->
            <!-- </b-link> -->
          </div>

          <b-card-body>
            <div class="item-wrapper">
              <div class="item-rating">
                <strong>Stock: </strong>
                {{ product.stock }}
                <!-- <ul class="unstyled-list list-inline">
                <li
                  v-for="star in 5"
                  :key="star"
                  class="ratings-list-item"
                  :class="{ 'ml-25': star - 1 }"
                >
                  <feather-icon
                    icon="StarIcon"
                    size="16"
                    :class="[
                      { 'fill-current': star <= product.rating },
                      star <= product.rating ? 'text-warning' : 'text-muted',
                    ]"
                  />
                </li>
              </ul> -->
              </div>
              <div>
                <h6 class="item-price" v-if="!product.priceByRange">
                  {{ product.price + "$" || "N/A" }}
                </h6>
                <h6 class="item-price" v-if="product.priceByRange">
                  {{
                    "Desde " +
                      product.priceFrom +
                      "$" +
                      " hasta " +
                      product.priceTo +
                      "$" || "N/A"
                  }}
                </h6>
              </div>
            </div>
            <h6 class="item-name">
              <!-- <b-link
              class="text-body"
              :to="{
                name: 'apps-e-commerce-product-details',
                params: { slug: product.slug },
              }"
            >
            </b-link> -->
              {{ product.name }}
            </h6>
            <strong>Estado: </strong>
            {{ tagsCondition(product.idCatCondicion) }}
            <br />
            <strong>En uso: </strong>
            {{ product.active ? "Sí" : "No" }}
            <br />
            {{ product.stringCategoriasTags || "N/A" }}
            <b-card-text class="item-description">
              {{ product.details }}
            </b-card-text>
          </b-card-body>
        </b-card>
      </section>

      <!-- Pagination -->
      <section v-if="!loading">
        <b-row>
          <b-col cols="12">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              pills
              first-number
              align="center"
              @change="handlePageChange"
              last-number
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </section>
    </b-card>
  </div>
</template>

<script>
import {
  BDropdown,
  BDropdownItem,
  BFormRadioGroup,
  BFormRadio,
  BRow,
  BCol,
  BInputGroup,
  BInputGroupAppend,
  BFormInput,
  BCard,
  BCardBody,
  BLink,
  BImg,
  BCardText,
  BButton,
  BPagination,
  BCarousel,
  BCarouselSlide,
  BTooltip,
  BCardHeader,
  BCardTitle,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Filterss from "../../components/filters/Filterss.vue";
// import { useResponsiveAppLeftSidebarVisibility } from "@core/comp-functions/ui/app";
// import ShopLeftFilterSidebar from "./ECommerceShopLeftFilterSidebar.vue";

// import { useEcommerceUi } from "../useEcommerce";
import {
  allProducts,
  deleteProduct,
  postFileExcelValery,
  createProductExcel,
  categoryProductsByCompany,
} from "@core/api/request/products";
import { getCompany } from "@core/api/request/company";
import { getCatalog } from "@core/api/request/catalogs";
import {
  getParams,
  showLoading,
  stopLoading,
  getParamsAll,
} from "@core/utils/utils";
import { canAccess } from "@/security/permissions/permissionHelper";

export default {
  directives: {
    Ripple,
  },
  components: {
    // BSV
    BDropdown,
    BDropdownItem,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BCard,
    BCardBody,
    BLink,
    BImg,
    BCardText,
    BButton,
    BPagination,
    BCarousel,
    BCarouselSlide,
    BTooltip,
    BCardHeader,
    BCardTitle,
    Filterss,
    // SFC
    // ShopLeftFilterSidebar,
  },
  directives: {
    "b-tooltip": BTooltip,
  },
  data: () => ({
    model: "products",
    companyGuid: null,
    loading: false,
    totalRows: 0,
    hasNextPage: true,
    currentPage: 1,
    perPage: 10,
    items: [],
    prodCondition: [],
    uploadFileName: null,
    appliedFilters: {},
    prodCondition: [],
    fildsToFilters: [
      {
        name: "name",
        type: "text",
        placeholder: "name",
        type: "search",
        visible: true,
      },
      {
        name: "category",
        title: "category",
        placeholder: "category",
        type: "select",
        options: [],
        visible: true,
        multiple: true,
        close: false,
      },
      {
        name: "price",
        title: "price",
        placeholder: "price",
        type: "number",
        options: [],
        visible: true,
        multiple: true,
        close: false,
      },
      {
        name: "idCatCondicion",
        title: "productCondition",
        placeholder: "productCondition",
        type: "select",
        options: [],
        visible: true,
        multiple: false,
        close: false,
      },
    ],
  }),

  computed: {
    canCreate() {
      return canAccess("Famcos Productos", "creation");
    },
    canShow() {
      return canAccess("Famcos Productos", "reading");
    },
    canEdit() {
      return canAccess("Famcos Productos", "edition");
    },
    canDelete() {
      return canAccess("Famcos Productos", "elimination");
    },
  },

  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
      this.hasNextPage = true;
      this.currentPage = 1;
      this.items = [];
      this.loadData();

      this.fildsToFilters.forEach((element) => {
        if (element.name === "category") {
          element.options = [];
        }
      });
    },
  },
  created() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.loadData();
  },
  mounted() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.addEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    label(field) {
      return `pages.products.table.${field}`;
    },
    async loadData() {
      try {
        this.loading = true;
        showLoading();
        const params = this.chargeParams();

        // Usamos Promise.all para cargar productos y catálogos en paralelo
        const [productsResp, catalogResp, categoryCompanyResp] =
          await Promise.all([
            allProducts(params),
            getCatalog(
              getParams([
                "itemsPage,1",
                "itemsRows,999",
                "guidCatalog,a5426eaf-8a96-42a2-a2b5-775fbc38fe09",
              ]),
            ),
            categoryProductsByCompany(
              getParams([
                `page,1`,
                `rows,999`,
                `guidCompany,${this.$store.state.appConfig.activeCompanyGuid}`,
              ]),
            ),
          ]);

        // Procesamos productos
        const products = _.get(productsResp, "data");
        this.items = products?.items || [];
        this.totalRows = products?.totalRows || 0;
        this.hasNextPage = products?.currentPage < products?.totalPages || 0;

        // Procesamos catálogo
        const condition = _.get(catalogResp, "data.listOfItems.items") || [];
        const transformedItems = condition.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        const category = _.get(categoryCompanyResp, "data.items") || [];

        const transformedCategory = category.map((item) => ({
          label: item.name,
          value: item.idCompanyCategoryProducts,
        }));

        this.prodCondition = transformedItems;

        this.fildsToFilters.forEach((element) => {
          if (element.name === "idCatCondicion") {
            element.options = transformedItems;
          }

          if (element.name === "category") {
            element.options = transformedCategory;
          }
        });
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error loading data", error);
      } finally {
        this.loading = false;
        stopLoading();
      }
    },
    validateFilters(filters) {
      // Validar nombre (no debe ser vacío ni contener solo espacios)
      if (filters.name && !filters.name.trim()) {
        console.error("El filtro de nombre no es válido.");
        return false;
      }

      // Validar categoría (debe existir en las opciones disponibles)
      if (
        filters.category &&
        !filters.category.every((cat) =>
          this.fildsToFilters
            .find((f) => f.name === "category")
            .options.some((opt) => opt.value === cat),
        )
      ) {
        console.error("El filtro de categoría no es válido.");
        return false;
      }

      // Validar condición del producto (debe existir en las opciones disponibles)
      if (
        filters.idCatCondicion &&
        !this.prodCondition.some(
          (cond) => cond.value === filters.idCatCondicion,
        )
      ) {
        console.error("El filtro de condición no es válido.");
        return false;
      }

      return true;
    },
    applyFilters(filters) {
      if (this.validateFilters(filters)) {
        this.appliedFilters = filters;
        this.currentPage = 1;
        this.hasNextPage = true;
        this.loadData();
      } else {
        console.error("Filtros no aplicados debido a validaciones fallidas.");
      }
    },
    resetFilters() {
      this.appliedFilters = {};

      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadData();
    },
    updloadValery() {
      this.uploadFileName = "valery";
      document.getElementById("files").click();
    },
    updloadProducts() {
      this.uploadFileName = "products";
      document.getElementById("files").click();
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      const validExtensions = ["xlsx"];
      const extension = file.name.split(".").pop().toLowerCase();
      const isValidExtension = validExtensions.includes(extension);
      if (!isValidExtension) {
        this.alertToast(
          "danger",
          "Error",
          `Tipo de archivo invalido: ${file.name}`,
          "AlertTriangleIcon",
        );
        return;
      }
      this.onTransFile(
        event?.target?.files,
        event.target.accept,
        event.target.multiple,
      );
    },
    onTransFile(files, accept, multiple) {
      switch (this.uploadFileName) {
        case "valery":
          this.chargeValery(files);
          break;
        case "products":
          this.chargeProducts(files);
          break;
      }
    },
    async chargeValery(files) {
      if (!this.companyGuid) {
        this.alertToast(
          "danger",
          "Error",
          "No hay una compañías seleccionada",
          "AlertTriangleIcon",
        );
        return;
      }
      try {
        showLoading();
        await postFileExcelValery(files[0], this.companyGuid)
          .then((resp) => {
            this.alertToast(
              "success",
              this.$t("upload"),
              resp.message,
              "CheckIcon",
            );
          })
          .catch((error) => {
            console.error("Error uploading Valery file", error.message);
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
          });
      } catch (error) {
        console.error("Error uploading Valery file", error.message);
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      } finally {
        stopLoading();
      }
    },
    async chargeProducts(files) {
      if (!this.companyGuid) {
        this.alertToast(
          "danger",
          "Error",
          "No hay una compañías seleccionada",
          "AlertTriangleIcon",
        );
        return;
      }
      try {
        showLoading();
        await createProductExcel(files[0], this.companyGuid)
          .then((resp) => {
            this.alertToast(
              "success",
              this.$t("upload"),
              resp.data.message,
              "CheckIcon",
            );
          })
          .catch((error) => {
            console.error("Error uploading excel file", error.message);
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
          });
      } catch (error) {
        console.error("Error uploading excel file", error.message);
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      } finally {
        stopLoading();
      }
    },
    async dowloandsCatalog() {
      try {
        showLoading();
        if (this.$store.state.appConfig.activeCompanyGuid != null) {
          await getCompany(this.$store.state.appConfig.activeCompanyGuid)
            .then((resp) => {
              const data = _.get(resp, "data");
              window.open(data.urlPdfCatalogProducts, "_blank");
            })
            .catch((error) => {
              this.alertToast(
                "danger",
                "Error",
                error.message,
                "AlertTriangleIcon",
              );
              console.error("Error downloading catalog", error);
            });
        } else {
          console.error("No se ha encontrado la compañía");
        }
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error downloading catalog", error);
      } finally {
        stopLoading();
      }
    },
    tagsCondition(idCondition) {
      const condition = this.prodCondition.find(
        (item) => item.value === idCondition,
      );
      return condition ? condition.label : "N/A";
    },

    chargeParams() {
      const arrParams = [];
      arrParams.push(`page,${this.currentPage}`);
      arrParams.push(`rows,${this.perPage}`);
      arrParams.push(`guidCompany,${this.companyGuid}`);

      // Aplicar filtros
      if (this.appliedFilters.name) {
        arrParams.push(`name,${this.appliedFilters.name}`);
      }
      if (this.appliedFilters.category) {
        const field = this.fildsToFilters.find(
          (model) => model.name === "category",
        );

        const selectedLabels = field.options
          .filter((option) =>
            this.appliedFilters.category.includes(option.value),
          )
          .map((option) => option.label);
        const categoryString = selectedLabels.join(", ");
        arrParams.push(`stringCategoriasTags,${categoryString}`);
      }
      if (this.appliedFilters.idCatCondicion) {
        arrParams.push(`idCatCondicion,${this.appliedFilters.idCatCondicion}`);
      }
      if (this.appliedFilters.price) {
        arrParams.push(`price,${this.appliedFilters.price}`);
      }

      return getParamsAll(arrParams);
    },

    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadData();
    },
    handlePerPageChange() {
      this.loadData();
    },
    onCreate() {
      this.$router.push({
        name: "famcosProductCreate",
        params: { option: 1 },
      });
    },
    onShow(guid) {
      this.$router.push({
        name: "famcosProductEdit",
        params: { option: 2, guid },
      });
    },
    onEdit(guid) {
      this.$router.push({
        name: "famcosProductEdit",
        params: { option: 3, guid },
      });
    },
    onClone(guid) {
      this.$router.push({
        name: "famcosProductEdit",
        params: { option: 4, guid },
      });
    },
    onDelete(guid) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yesDelete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          showLoading();
          deleteProduct(guid)
            .then(() => {
              stopLoading();
              this.$swal({
                icon: "success",
                title: this.$t("Deleted"),
                text: this.$t("beenDeleted"),
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.loadData();
            })
            .catch((error) => {
              console.error("error", error.message);
              stopLoading();
              this.alertToast(
                "danger",
                this.$t("codeAlert"),
                error.message,
                "AlertTriangleIcon",
              );
            });
        } else if (result.dismiss === "cancel") {
          this.message(
            this.$t("canceled"),
            this.$t("registerDeletedCanceled"),
            "error",
          );
        }
      });
    },
    onInfo() {
      console.log("Displaying tutorial info");
    },
    message(title, text, icon, html) {
      this.$swal({
        title,
        text,
        html,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },
    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce.scss";
</style>

<style lang="scss" scoped>
.item-view-radio-group ::v-deep {
  .btn {
    display: flex;
    align-items: center;
  }
}
.img-customer-slide {
  width: 285px;
  height: 200px;
}

.img-customer {
  width: 100%;
  height: auto;
  object-fit: fill;
}

.product-carousel {
  .carousel-inner {
    border-radius: 8px;
    overflow: hidden;
    aspect-ratio: 1 / 1; // Mantener relación cuadrada

    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .product-image {
    max-height: 250px;
    max-width: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
  }

  .image-wrapper {
    width: 100%;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
  }
}

// Estilos responsivos
// @media (max-width: 768px) {
//   .product-carousel {
//     max-width: 300px;

//     .carousel-control-prev-icon,
//     .carousel-control-next-icon {
//       width: 30px;
//       height: 30px;
//     }
//   }
// }

// @media (max-width: 576px) {
//   .product-carousel {
//     max-width: 250px;

//     .carousel-indicators {
//       bottom: -30px;

//       li {
//         width: 6px;
//         height: 6px;
//         margin: 0 2px;
//       }
//     }
//   }
// }

// Estilos existentes
// .item-view-radio-group ::v-deep {
//   .btn {
//     display: flex;
//     align-items: center;
//   }
// }
</style>
